import { Injectable } from '@angular/core';
import { UserStorageService } from './user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class GridStateService {

  private gridStateKey = "serverSidegridState";
  private gridClientStateKey = "clientSidegridState";

  constructor(private userStorageService: UserStorageService) {}

  async loadGridState(id:any): Promise<any> {
    const widgetState = await this.userStorageService.getGridState(id);
    if (widgetState && widgetState.config) {
      return widgetState.config;
    }
    return false;

    // const savedState = sessionStorage.getItem(this.gridStateKey);
    // if (savedState) {
    //   let getUserState = JSON.parse(savedState);
    //   if(getUserState['dashboardKey']==dashboardKey) {
    //     return JSON.parse(savedState);
    //   } else {
    //     return false;
    //   }
    // }
    // return false;
  }

  saveGridStates(config?:any) {
    this.userStorageService.saveGridStates(config)

    // let existingState = JSON.parse(sessionStorage.getItem(this.gridStateKey) || '{}');
    // const newState = { ...existingState, ...updatedState, ...config };
    // sessionStorage.setItem(this.gridStateKey, JSON.stringify(newState));
  }

  clearAll() {
    this.userStorageService.clearAllStates()
  }

  /**
   * Clears grid state for the given dashboardKey and type.
   */
 clearAllGridStates(): void {
  sessionStorage.removeItem(this.gridStateKey);
  sessionStorage.removeItem(this.gridClientStateKey);
  // console.log(`[GridStateService] Cleared ALL grid states`);
}

}
